import { Validator } from "../Validator"
import TranslationInput from "../Helpers/TranslationInput.svelte"

export default class TranslationValidator extends Validator {
    public readonly inputHelper = TranslationInput
    public readonly isMeta = true
    public readonly hideInputField = true
    constructor() {
        super("translation", "Makes sure the the string is of format `Record<string, string>` ")
    }

    isValid(value: string): boolean {
        try {
            JSON.parse(value)
            return true
        } catch (e) {
            return false
        }
    }
}
